import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { mutationEditorClear } from 'gql/mutations/editor';
import { useQueryLocalEditor } from 'gql/queries/local';
import { notify } from 'uikit/Notifications';

import QuestionImport from './QuestionImport';

const QuestionImportContainer = (props) => {
  const { t } = useTranslation();
  const handleClose = useCallback(
    (questions) => {
      if (Array.isArray(questions)) {
        if (!questions.length) {
          notify(
            'error',
            t(
              'Course/Teacher/Editor/QuestionImport/question-import-error-empty',
            ),
          );
        } else {
          notify(
            'success',
            t('Course/Teacher/Editor/QuestionImport/question-import-success', {
              count: questions.length,
            }),
          );
        }
      }
      mutationEditorClear();
    },
    [t],
  );
  const {
    data: {
      editor: { status: editorStatus },
    },
  } = useQueryLocalEditor();
  const isModalOpen = editorStatus === 'question-import';
  return (
    <QuestionImport
      handleModalClose={handleClose}
      isModalOpen={isModalOpen}
      t={t}
      {...props}
    />
  );
};

export default QuestionImportContainer;
